import React from 'react';

interface BoldIconProps {
    color?: string;
    width?: number;
    height?: number;
}

const BoldIcon: React.FC<BoldIconProps> = ({
    color = 'black',
    width = 9,
    height = 15
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 9 15"
            fill="none"
        >
            <path
                d="M0.5 6.78571V0.5H4.21429C5.95005 0.5 7.35714 1.90711 7.35714 3.64286C7.35714 5.37861 5.95005 6.78571 4.21429 6.78571H0.5ZM0.5 6.78571V14.2143H4.78571C6.83706 14.2143 8.5 12.5513 8.5 10.5C8.5 8.44865 6.83706 6.78571 4.78571 6.78571H0.5Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default BoldIcon;
